/**
 * Компонента добавленя нового свойства.
 * Для добавления свойства:
 * 1. Получение списка доступных свойств
 * 2. Отображение диалога с выбором свойства и ввода данных этого свойтсв
 * 3. Вызов метода добавления свойства
 */
import React from 'react';
import { Form, Icon, Input, Select, Checkbox, Row, Col } from 'antd';
import Label from '../widgets/Label';


const formItemLayout = {
  labelCol  : { xs: { span: 24 }, sm: { span: 6 }, },
  wrapperCol: { xs: { span: 24 }, sm: { span: 18 }, },
};

const { Option } = Select;

const makePredicates = (existing, factory, rdfType) => {
  const existingPredicates = existing.map(item => item.predicat.value);
  let predicates = factory.provider.getProperties(rdfType, "add_property");
  //console.log("AddProperty.js before", predicates);
  //Если нет ни одного свойства, то запрашиваем весь список
  if (Array.isArray(predicates) && predicates.length<1)
    predicates = factory.provider.getProperties(undefined, "add_property");
  predicates = predicates.filter (item => !existingPredicates.includes(item));
  //console.log("AddProperty.js after",predicates, existingPredicates);
  return predicates;
}
/** Форма добавления нового свойства. Обязательно указать IRI.
 * Для указания IRI можно либо ввести IRI либо выбрать из списка
 */
class NewPropertyElementForm extends React.Component {

  state = {
    EP:"2021",
    iri: "http://www.w3.org/ns/adms#",
  };

  handleIRIChange = e => {
    const value = e.target.value;
    const iri = (value && (value.startsWith("http://") || value.startsWith("https://")))? value : "http://www.w3.org/ns/adms#"+e.target.value;
    this.setState({iri});
  };

  handleLabelChange = e => {
    e.preventDefault();
    this.triggerChange({text: e.target.value });
  };

  handleOnChange = value => {
    this.triggerChange({ value });
  };

  triggerChange = changedValue => {
    console.log("AddProperty.js triggerChange", changedValue);
    const { onChange, value } = this.props;
    if (onChange) {
      onChange({
        ...value,
        ...changedValue,
      });
    }
  };

  render() {
    console.log(this);
    const {factory, rdfType, existing, IRI, lang } = this.props;
    const predicates = makePredicates(existing, factory, rdfType);
    const { getFieldDecorator } = this.props.form;
    return (
        <Form {...formItemLayout} className="ant-edit-form">
          <Form.Item label="Свойство" extra={IRI}>
            {getFieldDecorator('IRI', {
              rules: [{ required: true, message: 'Пожалуйста, выберите свойство для включения в карточку!' }],
            })(
              <Select
                placeholder="IRI свойства" 
                onChange={this.handleOnChange}>
                {predicates.map(item => (
                  <Option value={item}><Label iri={item}/> ({item})</Option>
                ))}
            </Select>
            )}
          </Form.Item>
        </Form>
    );
  }
}

/* <Select
showSearch
optionFilterProp="children"
filterOption={(input, option) =>
  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
}
placeholder="IRI свойства" 
onChange={this.handleOnChange}>
{predicates.map(item => (
  <Option value={item}><Label iri={item}/> ({item})</Option>
))}
</Select> */


/* <Form.Item label={<Label />}>
{getFieldDecorator('label', {
      initialValue: { text: "", lang: 'ru' },
      rules: [{ required: true, message: 'Пожалуйста, укажите наименование!' }],
})( <LabelInput />)}
</Form.Item> */

export default Form.create({ name: 'new_property_element' })(NewPropertyElementForm);